import { useMemo } from "react"

import {
    Layer,
    MapStyles,
    SPEEDINGS_LAYER,
    SPEEDINGS_SOURCE,
    useMapStateContext,
    useOrderingLayers,
} from "@l2r-front/l2r-map"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { useTheme } from "@l2r-front/l2r-ui"

import { useSpeedingsStateContext } from "../../contexts/SpeedingsContext"
import { getSpeedingsLayerStyle } from "../../utils/getSpeedingsConfig"

import { SpeedingsSource } from "../SpeedingsSource"

export function SpeedingsLayer() {

    const { selectedLinearLocations } = useNetworksStateContext()
    const { currentMapStyle } = useMapStateContext()
    const { currentActiveLayer, currentYear } = useSpeedingsStateContext()
    const theme = useTheme()

    const speedingsLayerConfig = useMemo(() => {
        const selectedRoad = selectedLinearLocations?.[0]?.road
        const referentialColor = currentMapStyle === MapStyles.plan ? theme.palette.map.darkReferential : theme.palette.map.lightReferential
        return getSpeedingsLayerStyle(referentialColor, theme, selectedRoad, currentYear, currentActiveLayer)
    }, [currentActiveLayer, currentMapStyle, theme, selectedLinearLocations, currentYear])

    useOrderingLayers([SPEEDINGS_LAYER])

    return (
        <SpeedingsSource
            id={SPEEDINGS_SOURCE}
            tolerance={.001}
        >
            <Layer
                id={SPEEDINGS_LAYER}
                {...speedingsLayerConfig}
            />
        </SpeedingsSource>
    )
}
